module.exports = __webpack_public_path__ + "img/3daad03.jpg";